const state = function () {
  return {
    processPaymentModalOpen: false,
    detailsModalOpenState: false,
    closeModalOnPaymentComplete: true,
    processPaymentCallback: null,
    orderToLoad: null,
    loadOrderTypes: true,
    orderDetails: {
      ORDER: {},
      loading: false,
      items: [
        {
          name: 'Class Processing Credit',
          quantity: 0,
          price: 0,
          min: 0,
          max: 999,
          orderType: 1
        },
        {
          name: 'Class Processing Credit',
          quantity: 0,
          price: 0,
          min: 0,
          max: 999,
          orderType: 2
        }
      ]
    },
    searchOrderTypes: [],
    userHelper: '',
    searchFields: {
      ORDER_ID: null,
      USER_ID: null,
      CLASS_ID: null,
      ORDER_START_DATE: null,
      ORDER_LAST_DATE: null,
      LK_ORDER_TYPE_ID: null
    },
    pendingPayment: {
      sameAsBilling: true,
      paymentType: null,
      paymentTypeId: null,
      canAdd: true,
      existingOrNew: null, // 
      processing: false,
      customer: {
        USER_ID: null,
        user: {
          USER_PHONE: ''
        },
        selectedPaymentProfile: null,
        paymentProfiles: []
      },
      billingAddress:{
        address1:'',
        city:'',
        state:'',
        zip:'',
        county:'',
      },
      mailingAddress: {
        address1: '',
        city: '',
        state: '',
        zip: '',
        county: ''
      },
      cc: {
        number: '',
        name: '',
        expiry: '',
        cvc: '',
        saveForLater: true
      },
      ach:{
        routing: null,
        account: null,
        name:'',
        saveForLater: true
      },
      moneyOrder: {
        notes: ''
      },
      accountCredits:{
        affiliate: null
      },
      adminBypass:{
        callback: null,
        password: '',
        authorized: false,
        authorizing: false,
        madeCall: false,
        overrideTotal: 0,
        flag: false,
        active: false,
        for: null
      },
      items:[]
    },
    newItemState () {
        return {
          quantity: 0,
          price: 0,
          min: 0,
          max: 999,
          shippingTotal: 0,
          orderType: null,
          shippingMethod: null,
          shippingMethodOptions: []
        }
    },
    loadingData: false,
    orderManagementModal: {
      open: false,
      selectedTab: 'details'
    },
    orderTypeModal: {
      open: false,
      mode: 'add'
    },
    orderDetailsModal: {
      mode: 'add',
      open: false
    },
    list: [],
    orderForm: {
      ORDER_TYPE_ID: null
    },
    orderTypeForm: {
      ORDER_TYPE_ID: null,
      ORDER_TYPE_NAME: '',
      PRICE: null,
      MIN_AMOUNT: 1,
      MAX_AMOUNT: 999,
      SHIPPING_METHODS: []
    },
    orderTypes: [],
    userOverrides: [],
    courseOverrides: [],
    affiliateOverrides: [],
    selectedUserOverrides: [],
    selectedCourseOverrides: [],
    selectedAffiliateOverrides: [],
    orderTypeOverrides: []
  }
}

export default {  
  ...state()
}

export const initialState = state()
